import { Input, InputTypes } from '@leegality/leegality-react-component-library';
import FieldLabel from '@components/form/field-label';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

const CommentField = ({
  label, mandatory, value, onChange,
}) => {
  const handleChange = useCallback((e) => onChange(e.target.value), [onChange]);

  return (
    <div>
      <div className="mb-1.5">
        <FieldLabel name={label} mandatory={mandatory} className="break-words" />
      </div>
      <Input type={InputTypes.TEXT} value={value} multiline multilineRowsCount={3} onChange={handleChange} />
    </div>
  );
};

CommentField.propTypes = {
  label: PropTypes.string,
  mandatory: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

CommentField.defaultProps = {
  label: '',
  mandatory: false,
  value: '',
};

export default CommentField;
